// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#chat2 .form-control{border-color:transparent}#chat2 .form-control:focus{border-color:transparent;box-shadow:inset 0 0 0 1px transparent}.divider:after,.divider:before{content:\"\";flex:1;height:1px;background:#eee}", ""]);
// Exports
module.exports = exports;
